// Destructure env vars from process
// See https://create-react-app.dev/docs/adding-custom-environment-variables/ for more info on caveats
const {
  REACT_APP_REMBLE_URL,
  REACT_APP_REMBLE_HOST,
  REACT_APP_REMBLE_THEME,
  REACT_APP_REMBLE_API_URL,
  REACT_APP_REMBLE_WP_API_URL,
  REACT_APP_REMBLE_VERSION,
  REACT_APP_REMBLE_ENV,
  REACT_APP_SENTRY_DSN,
  REACT_APP_REMBLE_FEATURED_CATEGORY_ID,
  REACT_APP_PRACTICES_AFFIRMATIONS_CATEGORY_ID,
  REACT_APP_PRACTICES_AFFIRMATIONS_START_YOUR_DAY_CATEGORY_ID,
  REACT_APP_PRACTICES_AFFIRMATIONS_TODAY_CATEGORY_ID,
  REACT_APP_PRACTICES_JOURNALING_CATEGORY_ID,
  REACT_APP_PRACTICES_JOURNALING_FREE_ENTRY,
  REACT_APP_PRACTICES_JOURNALING_DAILY_CATEGORY_ID,
  REACT_APP_PRACTICES_COMPLIMENTS_CATEGORY_ID,
  REACT_APP_PRACTICES_DATE_IDEAS_CATEGORY_ID,
  REACT_APP_PRACTICES_QA_CATEGORY_ID,
  REACT_APP_RESOURCE_PAGE_ABOUT_ID,
  REACT_APP_RESOURCE_PAGE_USER_GUIDE_ID,
  REACT_APP_RESOURCE_PAGE_RESOURCES_ID,
  REACT_APP_RESOURCE_PAGE_TERMS_OF_USE_ID,
  REACT_APP_RESOURCE_PAGE_PRIVACY_POLICY_ID,
  REACT_APP_PLANS_FEATURED_MONTHLY_ID,
  REACT_APP_PLANS_FEATURED_ANNUAL_ID,
  REACT_APP_PLANS_SELECTION_IDS,
  REACT_APP_FREEMIUM_CATEGORY_ID,
  REACT_APP_FREEMIUM_TOPIC_ID,
  REACT_APP_SUPPORT_REQUEST_WEBHOOK_URL,
  REACT_APP_CANCEL_SUBSCRIPTION_WEBHOOK_URL,
  REACT_APP_FREEMIUM_AFFIRMATION_CATEGORY_ID,
  REACT_APP_FREEMIUM_JOURNALING_CATEGORY_ID,
  REACT_APP_FREEMIUM_MEDITATION_ID,
  REACT_APP_FREEMIUM_RELATIONSHIP_QA_CATEGORY_ID,
  REACT_APP_FREEMIUM_COPINGSKILL_ID,
  REACT_APP_FREEMIUM_BREATHWORK_ID,
  REACT_APP_FREEMIUM_DATE_IDEAS_CATEGORY_ID,
  REACT_APP_FREEMIUM_COMPLIMENTS_CATEGORY_ID,
  REACT_APP_KLAVIYO_API_KEY,
  REACT_APP_MUX_ENVIRONMENT_KEY
} = process.env

const ENV_LOCAL = 'local'

// Assign environment variables to app properties
const app = {
  version: REACT_APP_REMBLE_VERSION,
  url: REACT_APP_REMBLE_URL,
  host: REACT_APP_REMBLE_HOST,
  environment: REACT_APP_REMBLE_ENV,
  is_local: REACT_APP_REMBLE_ENV === ENV_LOCAL,
  theme: REACT_APP_REMBLE_THEME,
  ios: {
    version: '1.3.1'
  },
  android: {
    version: '1.0.0'
  },
  api: {
    version: 1,
    url: REACT_APP_REMBLE_API_URL
  },
  wp_api: {
    remble_version: 1,
    wp_version: 2,
    lms_version: 2, // user progress requires v2
    url: REACT_APP_REMBLE_WP_API_URL,
    featured_category_id: REACT_APP_REMBLE_FEATURED_CATEGORY_ID
  },
  sentry: {
    dsn: REACT_APP_SENTRY_DSN
  },
  practices: {
    // NOTE: these keys MUST match the prefix of the WP post type. So, for example,
    // `Breathing_Activity` becomes `breathing`, `Coping_Activity`, becomes `coping`, etc.
    affirmation: {
      parent_cat_id: REACT_APP_PRACTICES_AFFIRMATIONS_CATEGORY_ID,
      today_cat_id: REACT_APP_PRACTICES_AFFIRMATIONS_TODAY_CATEGORY_ID,
      start_your_day_cat_id:
        REACT_APP_PRACTICES_AFFIRMATIONS_START_YOUR_DAY_CATEGORY_ID
    },
    journaling: {
      parent_cat_id: REACT_APP_PRACTICES_JOURNALING_CATEGORY_ID,
      free_entry_cat_id: REACT_APP_PRACTICES_JOURNALING_FREE_ENTRY,
      daily_cat_id: REACT_APP_PRACTICES_JOURNALING_DAILY_CATEGORY_ID
    },
    question: {
      parent_cat_id: REACT_APP_PRACTICES_QA_CATEGORY_ID
    },
    compliments: {
      parent_cat_id: REACT_APP_PRACTICES_COMPLIMENTS_CATEGORY_ID
    },
    date_ideas: {
      parent_cat_id: REACT_APP_PRACTICES_DATE_IDEAS_CATEGORY_ID
    }
  },
  resources: {
    pages: {
      about: REACT_APP_RESOURCE_PAGE_ABOUT_ID,
      user_guide: REACT_APP_RESOURCE_PAGE_USER_GUIDE_ID,
      resources: REACT_APP_RESOURCE_PAGE_RESOURCES_ID,
      terms_of_service: REACT_APP_RESOURCE_PAGE_TERMS_OF_USE_ID,
      privacy_policy: REACT_APP_RESOURCE_PAGE_PRIVACY_POLICY_ID
    }
  },
  plans: {
    selection_ids: REACT_APP_PLANS_SELECTION_IDS,
    featured_ids: {
      monthly: REACT_APP_PLANS_FEATURED_MONTHLY_ID,
      annual: REACT_APP_PLANS_FEATURED_ANNUAL_ID
    },
    free_category_id: REACT_APP_FREEMIUM_CATEGORY_ID,
    free_topic_id: REACT_APP_FREEMIUM_TOPIC_ID,
    free_affirmation_category_id: REACT_APP_FREEMIUM_AFFIRMATION_CATEGORY_ID,
    free_breathwork_id: REACT_APP_FREEMIUM_BREATHWORK_ID,
    free_journaling_category_id: REACT_APP_FREEMIUM_JOURNALING_CATEGORY_ID,
    free_meditation_id: REACT_APP_FREEMIUM_MEDITATION_ID,
    free_relationship_qa_category_id:
      REACT_APP_FREEMIUM_RELATIONSHIP_QA_CATEGORY_ID,
    free_coping_skill_id: REACT_APP_FREEMIUM_COPINGSKILL_ID,
    free_date_ideas_category_id: REACT_APP_FREEMIUM_DATE_IDEAS_CATEGORY_ID,
    free_compliments_category_id: REACT_APP_FREEMIUM_COMPLIMENTS_CATEGORY_ID
  },
  webhooks: {
    support_request: REACT_APP_SUPPORT_REQUEST_WEBHOOK_URL,
    subscription: REACT_APP_CANCEL_SUBSCRIPTION_WEBHOOK_URL
  },
  klaviyo: {
    api_key: REACT_APP_KLAVIYO_API_KEY
  },
  mux: {
    api_key: REACT_APP_MUX_ENVIRONMENT_KEY
  }
}

export { app, ENV_LOCAL }
